export default __webpack_public_path__ + "static/media/parent.cf023f3c.webp";